function setStyleRegisterForm() {
  if (BSS_B2B && BSS_B2B.RF) {
    const isRegisterForm = document.querySelectorAll("#RegisterForm");
    if (isRegisterForm) {
      const gridClass = document.querySelector(".grid");
      if (gridClass) {
        if (!gridClass.classList.contains("register_form_bss")) {
          gridClass.classList.add("register_form_bss");
          gridClass.querySelectorAll(".grid__item").forEach(function (item) {
            item.classList.add("register_form_bss_item");
          });
        }
      }
    }
  }
}

var counter = 0;
var maxAttempts = 10;
var interval = 1000;
var labelsBSS = document.querySelectorAll(".rendered-form label");

function callFunctionRepeatedly() {
  setStyleRegisterForm();
  labelsBSS = document.querySelectorAll(".rendered-form label");
  const registerform = document.querySelector("#RegisterForm");
  var labelForm = registerform.querySelectorAll("label");
  var allInputs = Array.from(
    registerform.querySelectorAll(".field input")
  ).concat(Array.from(registerform.querySelectorAll(".rendered-form input")));
  var filteredLabels = Array.from(labelForm).filter(
    (label) => 
    
      !(label.classList.contains("formbuilder-select-label") ||
      label.parentElement.classList.contains("formbuilder-radio") ||
      label.parentElement.classList.contains("formbuilder-date") ||
        label.parentElement.classList.contains("formbuilder-radio-group-label") ||
      label.parentElement.classList.contains("formbuilder-textarea"))
  );

  var filteredInputs = Array.from(allInputs).filter(
    (input) =>
      !(input.closest(".formbuilder-radio") ||
      input.parentElement.classList.contains("formbuilder-radio") ||
      input.parentElement.classList.contains("formbuilder-date"))
  );

  function updateLabelStyle(input, label) {
    if (input.value.trim() !== "" || input === document.activeElement) {
      label.style.top = ".5rem";
      label.style.left = "calc(var(--inputs-border-width) + 2rem)";
      label.style.fontSize = "1rem";
      label.style.letterSpacing = ".04rem";

      input.style.padding = "2.2rem 1.5rem .8rem 2rem";
      input.style.margin = "var(--inputs-border-width)";
    } else {
      label.style.top = "calc(1rem + var(--inputs-border-width))";
      label.style.left = "calc(var(--inputs-border-width) + 2rem)";
      label.style.fontSize = "1.6rem";
      label.style.letterSpacing = ".1rem";

      input.style.padding = "1.5rem";
      input.style.margin = "var(--inputs-border-width)";
    }
  }

  filteredInputs.forEach((input, index) => {
    input.addEventListener("input", () =>
      updateLabelStyle(input, filteredLabels[index])
    );
    input.addEventListener("focus", () =>
      updateLabelStyle(input, filteredLabels[index])
    );
    input.addEventListener("blur", () =>
      updateLabelStyle(input, filteredLabels[index])
    );
  });
  if (labelsBSS.length > 0 || counter >= maxAttempts) {
    console.log("Stopped calling function.");
    return;
  }
  counter++;
  setTimeout(callFunctionRepeatedly, interval);
}

document.addEventListener("DOMContentLoaded", function () {
  callFunctionRepeatedly();
});
